import React, { createContext, useContext, useState } from "react";

const ColorContext = createContext();

export const useColor = () => {
  return useContext(ColorContext);
};

export const ColorProvider = ({ children }) => {
  const [selectedColored, setSelectedColored] = useState(""); // Default color

  const setColored = (color) => {
    setSelectedColored(color);
  };

  return (
    <ColorContext.Provider value={{ selectedColored, setColored }}>
      {children}
    </ColorContext.Provider>
  );
};
